import script from "./left-right-layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./left-right-layout.vue?vue&type=script&lang=ts&setup=true"

import "./left-right-layout.vue?vue&type=style&index=0&id=dcec6c50&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcec6c50"]])

export default __exports__